import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ArrowRightCircleStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12ZM22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12Z"
				fill="currentColor"
			/>
			<path
				d="M12.9697 8.96973C13.2443 8.69516 13.6791 8.67768 13.9736 8.91797L14.0303 8.96973L16.5303 11.4697C16.6708 11.6103 16.7499 11.8013 16.75 12C16.75 12.1989 16.6709 12.3906 16.5303 12.5312L14.0303 15.0303C13.7374 15.3231 13.2626 15.3231 12.9697 15.0303C12.6769 14.7374 12.6769 14.2626 12.9697 13.9697L14.1895 12.75H8C7.58579 12.75 7.25 12.4142 7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H14.1895L12.9697 10.0303L12.918 9.97363C12.6777 9.67905 12.6951 9.24432 12.9697 8.96973Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ArrowRightCircleStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ArrowRightCircleStrokeIcon;
